var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.788,
    height: 30,
    viewBox: "0 0 19.788 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attraction_Logo",
    "data-name": "Attraction Logo",
    transform: "translate(0.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38232",
    "data-name": "Path 38232",
    d: "M5.592,22.68h1.1V20.173A37.608,37.608,0,0,1,2.329,14.9,14.888,14.888,0,0,1-.05,9.469l-.006-.031V9.4l0-.1v0A8.62,8.62,0,0,1,3.118,2.312,10.877,10.877,0,0,1,9.735,0H9.8l.033,0,.033,0h.067a10.877,10.877,0,0,1,6.617,2.308A8.62,8.62,0,0,1,19.73,9.3v0l0,.1v.038l-.006.031A14.888,14.888,0,0,1,17.342,14.9a37.755,37.755,0,0,1-4.363,5.269V22.68h1.1a.843.843,0,0,1,.6.249h0a.843.843,0,0,1,.249.6v4.721A1.754,1.754,0,0,1,13.178,30H6.494a1.758,1.758,0,0,1-1.752-1.752V23.527a.852.852,0,0,1,.249-.6h0A.843.843,0,0,1,5.592,22.68ZM9.836.8a3.105,3.105,0,0,0-1,.3c-1.147.569-1.816,1.86-2.145,3.522a20.144,20.144,0,0,0-.061,6,32.872,32.872,0,0,0,2.321,8.994h1.766a32.879,32.879,0,0,0,2.319-8.994,20.144,20.144,0,0,0-.061-6c-.329-1.662-1-2.953-2.143-3.522A3.121,3.121,0,0,0,9.836.8Zm2.306.266a6.393,6.393,0,0,1,1.616,3.4,20.908,20.908,0,0,1,.071,6.244,34.771,34.771,0,0,1-2.241,8.9h.827a36.8,36.8,0,0,0,4.265-5.15,14.165,14.165,0,0,0,2.258-5.11V9.3a7.852,7.852,0,0,0-2.884-6.368A9.625,9.625,0,0,0,12.142,1.065ZM8.082,19.616a34.692,34.692,0,0,1-2.239-8.9,20.908,20.908,0,0,1,.071-6.244,6.393,6.393,0,0,1,1.616-3.4A9.613,9.613,0,0,0,3.618,2.928,7.846,7.846,0,0,0,.735,9.3v.061a14.158,14.158,0,0,0,2.256,5.11,36.825,36.825,0,0,0,4.267,5.15Zm4.1.835h-4.7V22.68h4.7Zm1.9,3.024H5.592a.06.06,0,0,0-.038.015.05.05,0,0,0-.015.038v4.721a.957.957,0,0,0,.954.954h6.684a.957.957,0,0,0,.954-.954V23.527a.05.05,0,0,0-.052-.052Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttraction);
export default __webpack_public_path__ + "static/media/attraction.7cabb81b5a726328f2ee62b2dff31557.svg";
export { ForwardRef as ReactComponent };